import * as Yup from 'yup';

declare module 'yup' {
  interface StringSchema {
    requiredNonEmpty(message?: string): this;
  }
  interface MixedSchema<TType, TContext> {
    fileValidation(
      validExtensions: string[],
      maxSize: number,
      tooLargeMessage: string,
      supportedMessage: string
    ): MixedSchema<TType, TContext>;
  }
}

export const addYupCustomMethods = () => {
  // eslint-disable-next-line no-prototype-builtins
  if (!Yup.string().hasOwnProperty('requiredNonEmpty')) {
    // Extend Yup with the custom method
    Yup.addMethod(Yup.string, 'requiredNonEmpty', function (message = 'This field is required') {
      return this.required(message).test('requiredNonEmpty', message, (value) => {
        return /^\s*\S[\s\S]*$/.test(value); // Ensures at least one non-whitespace character
      });
    });
  }
  // eslint-disable-next-line no-prototype-builtins
  if (!Yup.mixed<File>().hasOwnProperty('fileValidation')) {
    Yup.addMethod(
      Yup.mixed,
      'fileValidation',
      function (validExtensions: string[], maxSize: number, tooLargeMessage: string, supportedMessage: string) {
        return this.test('fileSize', tooLargeMessage, (value) => {
          if (!value) {
            return false;
          }
          let file = undefined;
          if (Array.isArray(value) && value.length > 0) {
            file = value[0] as File;
          } else if (typeof value === 'object') {
            file = value as File;
          }
          if (!file) {
            return false;
          }
          return file.size <= maxSize; // 10MB in bytes
        }).test('fileType', supportedMessage, (value) => {
          if (!value || (Array.isArray(value) && value.length === 0)) {
            return false;
          }
          let file = undefined;
          if (Array.isArray(value) && value.length > 0) {
            file = value[0] as File;
          } else if (typeof value === 'object') {
            file = value as File;
          }
          if (!file) {
            return false;
          }
          const fileExtension = file.name.split('.').pop()?.toLowerCase();
          return fileExtension ? validExtensions.includes(fileExtension) : false;
        });
      }
    );
  }
};
